import {default as VtxDatePicker} from './VtxDatePicker';
import {default as VtxMonthPicker} from './VtxMonthPicker';
import {default as VtxRangePicker} from './VtxRangePicker';
import {default as VtxTimePicker} from './VtxTimePicker';
import {default as VtxYearPicker} from './VtxYearPicker';

let VtxDate = {
    VtxDatePicker,
    VtxMonthPicker,
    VtxRangePicker,
    VtxTimePicker,
    VtxYearPicker
};

export default VtxDate;
export {VtxDatePicker,VtxMonthPicker,VtxRangePicker,VtxTimePicker,VtxYearPicker};